export default __webpack_public_path__ + "static/Workout-With-A-View-Amrita-Yoga-and-Wellness-7c3a3f871466e8b6e709b0f01aac426f.jpg";